/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type FetchImageFromURLForm2 = {
  /**
   * The URL to fetch the image from
   */
  url: string;
};

/** @internal */
export type FetchImageFromURLForm2$Outbound = {
  url: string;
};

/** @internal */
export const FetchImageFromURLForm2$outboundSchema: z.ZodMiniType<
  FetchImageFromURLForm2$Outbound,
  FetchImageFromURLForm2
> = z.object({
  url: z.string(),
});

export function fetchImageFromURLForm2ToJSON(
  fetchImageFromURLForm2: FetchImageFromURLForm2,
): string {
  return JSON.stringify(
    FetchImageFromURLForm2$outboundSchema.parse(fetchImageFromURLForm2),
  );
}
